export default {
  data () {
    return {
      results: [],
      loading: false
    }
  },
  methods: {
    async doSearch (filters = {}, successCallback = () => {}, errorCallback = () => {}) {
      filters.value = String(filters.value || '')
      this.loading = true
      const { status, payload } = await this.$post('v1/clients/search', {
        filter: filters.value,
        with_addresses: filters.with_addresses || 'NONE',
        with_phones: filters.with_phones || 'NONE',
        with_emails: filters.with_emails || 'NONE',
        parent_of_client: filters.parent_of_client || null
      })
      this.loading = false
      if (status === 'success') {
        this.results = payload.clients
        successCallback()
      }
      else {
        errorCallback()
      }
    }
  }
}
